import type { ItemCardUserImage } from '../types/pointItemNote';

/** 아이템 카드 기본(샘플) 이미지 개수 — IconBasic 1~40 */
export const ITEM_CARD_BASIC_IMAGE_COUNT = 40;

/** 사용자 등록 이미지 라이브러리 상한(=고정 슬롯 수) */
export const ITEM_CARD_USER_IMAGE_MAX = 40;

export const ITEM_CARD_BASIC_OPTIONS: string[] = Array.from(
  { length: ITEM_CARD_BASIC_IMAGE_COUNT },
  (_, i) => String(i + 1)
);

export function getIconBasicImagePath(numStr: string): string {
  return `/CardIcon/IconBasic/IconBasic-${numStr}.png`;
}

export function isNumericCardImage(value?: string | null): boolean {
  if (!value) return false;
  return /^\d+$/.test(value);
}

/** 표시용 src. 없음/default → null */
export function resolveItemCardImageSrc(cardImage?: string | null): string | null {
  const v = (cardImage ?? '').trim();
  if (!v || v === 'default') return null;
  if (isNumericCardImage(v)) return getIconBasicImagePath(v);
  return v;
}

export type ItemCardImageLocalSlot = {
  /** dnd-kit sortable id (이미지 id 또는 empty-* ) */
  key: string;
  image: ItemCardUserImage | null;
};

function newEmptySlotKey(index: number): string {
  return `empty-${index}-${Math.random().toString(36).slice(2, 8)}`;
}

/** 저장된 이미지 목록 → 항상 MAX칸 슬롯(빈 칸 포함) */
export function buildItemCardImageSlots(
  images: ItemCardUserImage[]
): ItemCardImageLocalSlot[] {
  const cells: Array<ItemCardUserImage | null> = Array.from(
    { length: ITEM_CARD_USER_IMAGE_MAX },
    () => null
  );
  const list = images.slice(0, ITEM_CARD_USER_IMAGE_MAX);
  const hasSlotIndex = list.some(
    (img) => typeof img.slotIndex === 'number' && Number.isFinite(img.slotIndex)
  );

  if (hasSlotIndex) {
    const leftovers: ItemCardUserImage[] = [];
    for (const img of list) {
      const idx = Math.trunc(Number(img.slotIndex));
      if (Number.isFinite(idx) && idx >= 0 && idx < ITEM_CARD_USER_IMAGE_MAX && cells[idx] == null) {
        cells[idx] = img;
      } else {
        leftovers.push(img);
      }
    }
    for (const img of leftovers) {
      const free = cells.findIndex((c) => c == null);
      if (free < 0) break;
      cells[free] = img;
    }
  } else {
    list.forEach((img, i) => {
      cells[i] = img;
    });
  }

  return cells.map((image, index) => ({
    key: image?.id ?? newEmptySlotKey(index),
    image,
  }));
}

/** 슬롯 → 저장용 이미지 목록(slotIndex 부여) */
export function flattenItemCardImageSlots(
  slots: ItemCardImageLocalSlot[]
): ItemCardUserImage[] {
  const out: ItemCardUserImage[] = [];
  slots.forEach((slot, slotIndex) => {
    if (!slot.image) return;
    out.push({ ...slot.image, slotIndex });
  });
  return out;
}

export function itemCardSlotsSignature(slots: ItemCardImageLocalSlot[]): string {
  return slots.map((s) => (s.image ? s.image.id : `e:${s.key}`)).join('|');
}
